export default {
    autoComplete(searchText) {
        return DMUtils.http({
            method: 'GET',
            url: '/Institution/Autocomplete',
            params: { SearchText: searchText }
        }, true);
    },
	getAll(dto) {
        if (!dto.IntermediaryID) {
            dto.IntermediaryID = -1;
        }

        if (!dto.SystemID) {
            dto.SystemID = -1;
        }

        return DMUtils.http({
            method: 'POST',
            url: '/Institution/GetAll',
            data: dto,
        });
    },
    getAllDropdown() {
        return DMUtils.http({
            method: 'GET',
            url: '/Institution/GetAllDropdown',
        });
    },
    getByID(institutionID) {
        return DMUtils.http({
            method: 'GET',
            url: '/Institution/GetByID',
            params: { InstitutionID : institutionID },
        });
    },
    create(dto) {   
        if (!dto.DegreeTypeCode) {
            dto.DegreeTypeCode = -1;
        }  

        if (!dto.FundingTypeCode) {
            dto.FundingTypeCode = -1;
        }

        if (!dto.PrimaryIntermediaryID) {
            dto.PrimaryIntermediaryID = -1;
        }

        if (!dto.StateCodeID) {
            dto.StateCodeID = -1;
        }

        return DMUtils.http({
            method: 'POST',
            url: '/Institution/Create',
            data: dto
        });
    },
    update(dto) {
        if (!dto.DegreeTypeCode) {
            dto.DegreeTypeCode = -1;
        }  

        if (!dto.FundingTypeCode) {
            dto.FundingTypeCode = -1;
        }

        if (!dto.PrimaryIntermediaryID) {
            dto.PrimaryIntermediaryID = -1;
        }

        if (!dto.StateCodeID) {
            dto.StateCodeID = -1;
        }
        
        return DMUtils.http({
            method: 'POST',
            url: '/Institution/Update',
            data: dto,
        });
    },
    getDegreeTypes() {
        return DMUtils.http({
            method: 'GET',
            url: '/Institution/GetDegreeTypes',
        });
    },
    getFundingTypes() {
        return DMUtils.http({
            method: 'GET',
            url: '/Institution/GetFundingTypes',
        });
    },
    getStates() {
        return DMUtils.http({
            method: 'GET',
            url: '/State/GetAllDropdown',
        });
    },
}